module.exports = __webpack_public_path__ + "static/headerinfoicon-0423c99527707b8f1b2cc44fb0967b32.svg";